<template>
  <div class="collection" @click="$emit('toCollection')">
    <div class="left">
      <div class="top">
        <img class="icon" src="@/assets/icon/heji_file_blue.png" alt="" />
        <span class="title">{{ title || "---" }} </span>
        <img class="rightIcon" src="@/assets/icon/right.png" />
      </div>
      <div class="bottom" v-if="num">{{ num }}</div>
    </div>
    <div
      class="right"
      v-if="show_follow"
      :class="{ switch: follow_switch }"
      @click.stop="$emit('handleSwitch')"
    >
      <img
        :src="
          require(follow_switch
            ? '@/assets/icon/dingyue_file_white.png'
            : '@/assets/icon/dingyue_border_blue.png')
        "
        alt=""
      />
      <span>{{ follow_switch ? "已订阅" : "订阅" }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Collection",
  props: {
    title: {
      type: String,
    },
    follow_switch: {
      type: Boolean,
    },
    num: {
      type: String,
    },
    show_follow: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.collection {
  height: 100px;
  width: 100%;
  background: #f4f4f4;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  .left {
    .top {
      display: flex;
      align-items: center;
      cursor: pointer;
      .icon {
        width: 32px;
        height: 32px;
      }
      .title {
        font-size: 20px;
        font-weight: 400;
        color: #222222;
        margin: 0 10px;
      }
      .rightIcon {
        width: 7px;
        height: 14px;
      }
    }
    .bottom {
      font-size: 14px;
      font-weight: 400;
      color: #222222;
      margin-top: 5px;
    }
  }
  .right {
    width: 150px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    border: 1px solid #2a63f3;
    font-size: 20px;
    font-weight: 400;
    color: #2a63f3;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
  }
  .switch {
    background-color: #2a63f3;
    color: white;
  }
}
</style>
